import styled from 'styled-components';

export const GridContainer = styled.section`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	overflow: hidden;
	
	.ant-table-wrapper {
		flex: 1;
		min-width: 0;
	}
`;